var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inquire-container" }, [
      _c("picture", [
        _c("source", {
          attrs: {
            media: "(max-width: 767px)",
            srcset:
              "https://cdn.shopify.com/s/files/1/1363/8433/files/swag_section_mobile.png?v=1730316697"
          }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "lazyload main-image",
          attrs: {
            src:
              "https://cdn.shopify.com/s/files/1/1363/8433/files/swag_section-min.png?v=1730316724",
            alt: "goc"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-container" }, [
        _c("h2", [_vm._v("Let them pick swag")]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Work with our team to create "),
          _c("br", { staticClass: "mobile" }),
          _vm._v(" completely custom gifts for your team "),
          _c("br", { staticClass: "mobile" }),
          _vm._v(" to pick from."),
          _c("br", { staticClass: "desktop" }),
          _c("strong", [_vm._v("Get in touch to get started.")])
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "happybox-button white border",
            attrs: {
              href: "/pages/submit-an-inquiry-concierge-gifting",
              target: "_blank"
            }
          },
          [_vm._v("Request a Proposal")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }